import React, { useEffect, useState } from "react";
import HtmlHead from "../components/html-head/HtmlHead";
import { Link, useNavigate } from "react-router-dom";
import { Button, Col, Container, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { ApiService } from "./../helpers/services/apiSrevice";
import { IdentityService } from "./../helpers/services/identityService";
import { setToken, setUserData } from "../store/reducers/userReducer";
import AlertService from "../helpers/services/alertService";
import Marquee from "../components/marquee/Marquee";
import useWindowSize from "../components/hooks/useWindowSize";
import { FaArrowLeft } from "react-icons/fa6";


const Login = () => {
	const title = "Логин";
	const description = "";
	const windowSize = useWindowSize();
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const { user } = useSelector(state => state.user);

	const [isLoading, setIsLoading] = useState(false);
	const [values, setValues] = useState({
		email: "",
		password: "",
		rememberMe: false,
	});

	useEffect(() => {
		if (user) {
			navigate("/");
		}
	}, [user]);

	const getCurrentUser = async () => {
		try {
			const userResponse = await ApiService.getCurrentUser();
			localStorage.setItem("user", JSON.stringify(userResponse.data));
			dispatch(setUserData(userResponse.data));
		} catch (error) {
			AlertService.alert("warning", error);
			localStorage.removeItem("token");
			dispatch(setToken(null));
		} finally {
			setIsLoading(false);
		}
	};

	const onSubmit = async event => {
		event && event.preventDefault();

		if (
			!values.email.trim().length ||
			!values.password.trim().length ||
			isLoading
		) {
			return false;
		}

		setIsLoading(true);
		const formData = new FormData();
		formData.append("username", values.email);
		formData.append("password", values.password);
		try {
			const response = await IdentityService.userLogin(formData);
			if (response && response.data) {
				const token = response.data.accessToken;
				if (token) {
					localStorage.setItem("token", token);
					dispatch(setToken(token));
					setTimeout(() => {
						getCurrentUser();
					}, 100);
				} else {
					throw new Error("Неверный адрес электронной почты или пароль.");
				}
			}
		} catch (error) {
			AlertService.alert("warning", error.message);
			setIsLoading(false);
		}
	};

	return (
		<>
			<Container fluid className="login p-4 pb-5">
				<HtmlHead title={title} description={description} />
				<div className="d-flex justify-content-between">
					<Link
						to="/"
						className="header-button text-nowrap back-button d-flex gap-1 align-items-center border-1 ">
						<FaArrowLeft size={18} className="mt-1" />
						<span>на главную</span>
					</Link>
				</div>
				<Row className="mt-5">
					<Col lg={6} className="mt-3 mt-lg-0">
						<div className="border-dashed radius-50 p-4 pt-4 bg-white">
							<p className="title">ВХОД</p>
							<form onSubmit={onSubmit} className="form">
								<div className="mb-4">
									<label id="email">Ваша почта</label>
									<input
										id="email"
										className="border-1 radius-20 p-3 w-100"
										value={values.email}
										type="email"
										onChange={event =>
											setValues(values => ({
												...values,
												email: event.target.value,
											}))
										}
									/>
								</div>
								<div className="mb-4">
									<label htmlFor="password">Пароль</label>
									<input
										id="password"
										className="border-1 radius-20 p-3 w-100"
										value={values.password}
										type="password"
										onChange={event =>
											setValues(values => ({
												...values,
												password: event.target.value,
											}))
										}
									/>
								</div>
								<div>
									<Button
										type="submit"
										variant="dark"
										className="radius-20 py-2 w-100">
										{isLoading ? "Загрузка..." : "Войти"}
									</Button>
								</div>
								<Link to="/forgot-password" className="link">
									Забыли пароль?
								</Link>
							</form>
						</div>
					</Col>
					<Col lg={6} className="mt-3 mt-lg-0">
						<div className="radius-50 p-0 p-lg-4 pt-3 pt-lg-0 h-100">
							<div className="text">
								<p className="mb-4">
									Мы зарегистрируем Ваш личный кабинет при покупке курса на
									сайте. Инструкция по входу на сайт будет выслана автоматически
									на указанную при оплате почту.
								</p>
								<p className="mb-4">
									{" "}
									Если Вы забыли пароль, но не имеете доступа к почте,
									пожалуйста, обратитесь в техподдержку сайта:
								</p>
								<p className="ms-4">
									<span className="d-block">
										{" "}
										• на почту support@govorok-moscow.ru
									</span>
									<span className="d-block"> • в телеграм @govoroksupport</span>
								</p>
							</div>
						</div>
					</Col>
				</Row>
			</Container>
			<Marquee
				content={
					windowSize.width > 1024
						? [
							"логопед-дефектолог",
							"наталья смагина",
							"логопед-дефектолог",
							"наталья смагина",
						]
						: ["логопед-дефектолог", "Наталья Смагина"]
				}
				blockClassName="dark-bg"
			/>
		</>
	);
};

export default Login;
